import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { theme } from '../styles/theme';

const NotFoundContainer = styled.div`
  text-align: center;
  padding: ${theme.spacing['2xl']} ${theme.spacing.xl};
  max-width: 600px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: ${theme.typography.fontSize['4xl']};
  color: ${theme.colors.primary.main};
  margin-bottom: ${theme.spacing.lg};
`;

const Subtitle = styled.p`
  font-size: ${theme.typography.fontSize.xl};
  color: ${theme.colors.text.secondary};
  margin-bottom: ${theme.spacing.xl};
`;

const HomeButton = styled(Link)`
  display: inline-block;
  background-color: ${theme.colors.primary.main};
  color: white;
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.full};
  text-decoration: none;
  font-weight: 500;
  transition: transform 0.2s ease, background-color 0.2s ease;

  &:hover {
    transform: scale(1.05);
    background-color: ${theme.colors.primary.dark};
  }
`;

const NotFoundPage = () => {
  return (
    <Layout>
      <NotFoundContainer>
        <Title>404 - Page Not Found</Title>
        <Subtitle>
          Oops! The page you're looking for doesn't exist. Let's get you back on track.
        </Subtitle>
        <HomeButton to="/">
          Return to Home
        </HomeButton>
      </NotFoundContainer>
    </Layout>
  );
};

export default NotFoundPage; 